import React, { useEffect, useState, Fragment } from "react";
import { Dialog, Transition } from "@headlessui/react";
import axios from "axios";
import { useAuth } from "../../context/auth";
import {
  ArrowCircleLeftIcon,
  ArrowCircleRightIcon,
} from "@heroicons/react/solid";
import { Link, useNavigate } from "react-router-dom";
import { useQuery } from "react-query";
import { MdBathtub, MdBed } from "react-icons/md";
import { BiArea } from "react-icons/bi";
import { AiFillEye } from "react-icons/ai";
import { useParams } from "react-router-dom";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import GoogleMapReact from "google-map-react";
import { FaMapMarkerAlt } from "react-icons/fa";
import { BsFillPatchCheckFill } from "react-icons/bs";
import { ThreeDots } from "react-loader-spinner";
import { confirmAlert } from "react-confirm-alert"; // Import
import "react-confirm-alert/src/react-confirm-alert.css";
import { ToastContainer, toast, Zoom, Slide } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const AdsDetail = () => {
  const { token } = useAuth();
  const { id } = useParams();
  const navigate = useNavigate();
  const [acceptedId, setAcceptedId] = useState(null);
  const [rejectedId, setRejectedId] = useState(null);
  const headers = {
    "Content-Type": "application/json",
    Accept: "application/json",
    Authorization: `Bearer ${token}`,
  };
  const responsive = {
    superLargeDesktop: {
      breakpoint: { max: 4000, min: 1024 },
      items: 2,
    },
    desktop: {
      breakpoint: { max: 1024, min: 768 },
      items: 2,
    },
    tablet: {
      breakpoint: { max: 768, min: 640 },
      items: 2,
    },
    mobile: {
      breakpoint: { max: 640, min: 0 },
      items: 1,
    },
  };
  const defaultProps = {
    center: {
      lat: 9.013857199050697,
      lng: 38.753744567168226,
    },
    zoom: 11,
  };
  const customLeftArrow = (
    <div className="absolute arrow-btn left-1 text-center cursor-pointer ">
      <ArrowCircleLeftIcon className="h-10  text-white hover:text-main-color w-full" />
    </div>
  );

  const customRightArrow = (
    <div className="absolute arrow-btn right-1 text-center  cursor-pointer  ">
      <ArrowCircleRightIcon className="h-10  text-white hover:text-main-color w-full" />
    </div>
  );
  const propertyDetailsData = useQuery(
    ["propertyDetailsDataApi", id],
    async () =>
      await axios.get(
        `${process.env.REACT_APP_BACKEND_URL}ads/company/ad/${id}`,
        {
          headers,
        }
      ),
    {
      keepPreviousData: false,
      refetchOnWindowFocus: false,
      retry: false,
      enabled: !!token,
      onSuccess: (res) => {},
    }
  );

  //accept ad request
  const handleAccept = (id) => {
    confirmAlert({
      customUI: ({ onClose }) => {
        return (
          <div className="bg-[#edf2f6] max-w-2xl mx-auto p-4 py-4 flex items-center flex-col space-y-2">
            <h1 className="text-dark-color font-bold text-center">
              Are You Sure, You want to accept this ad
            </h1>

            <div className="flex items-center justify-center space-x-5 w-full">
              <button
                onClick={onClose}
                className="bg-blue-bg rounded-sm text-center
                     px-5 p-2 font-medium text-sm text-white capitalize"
              >
                No
              </button>
              <button
                onClick={() => {
                  // deleteCompanyMutationHandler(id);
                  setAcceptedId(id);
                  onClose();
                }}
                className="bg-red-500 rounded-sm text-center
              px-5 p-2 font-medium text-sm text-white capitalize"
              >
                Yes
              </button>
            </div>
          </div>
        );
      },
    });
  };
  //reject property ad request
  const handleReject = (id) => {
    confirmAlert({
      customUI: ({ onClose }) => {
        return (
          <div className="bg-[#edf2f6] max-w-2xl mx-auto p-4 py-4 flex items-center flex-col space-y-2">
            <h1 className="text-dark-color font-bold text-center">
              Are You Sure, You want to reject this ad
            </h1>

            <div className="flex items-center justify-center space-x-5 w-full">
              <button
                onClick={onClose}
                className="bg-blue-bg rounded-sm text-center
                     px-5 p-2 font-medium text-sm text-white capitalize"
              >
                No
              </button>
              <button
                onClick={() => {
                  // deleteCompanyMutationHandler(id);
                  setRejectedId(id);
                  onClose();
                }}
                className="bg-red-500 rounded-sm text-center
              px-5 p-2 font-medium text-sm text-white capitalize"
              >
                Yes
              </button>
            </div>
          </div>
        );
      },
    });
  };
  //accept ads
  const acceptAdData = useQuery(
    ["acceptAdApi", acceptedId],
    async () =>
      await axios.get(
        `${process.env.REACT_APP_BACKEND_URL}ads/accept/${acceptedId}`,
        {
          headers,
        }
      ),
    {
      keepPreviousData: false,
      refetchOnWindowFocus: false,
      retry: false,
      enabled: !!token && !!acceptedId,
      onSuccess: (res) => {
        toast.info(
          "Ad request accepted successfully",
          { theme: "colored" },
          {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: false,
            draggable: true,
            progress: undefined,
          }
        );
        setTimeout(() => {
          setAcceptedId(null);
          navigate("/ads");
        }, 2000);
      },
      onError: () => {
        setAcceptedId(null);
      },
    }
  );

  //reject api call
  const rejectAdData = useQuery(
    ["rejectAdApi", rejectedId],
    async () =>
      await axios.get(
        `${process.env.REACT_APP_BACKEND_URL}ads/reject/${rejectedId}`,
        {
          headers,
        }
      ),
    {
      keepPreviousData: false,
      refetchOnWindowFocus: false,
      retry: false,
      enabled: !!token && !!rejectedId,
      onSuccess: (res) => {
        toast.info(
          "Ad request rejected successfully",
          { theme: "colored" },
          {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: false,
            draggable: true,
            progress: undefined,
          }
        );
        setTimeout(() => {
          setRejectedId(null);
          navigate("/ads");
        }, 2000);
      },
      onError: () => {
        setRejectedId(null);
      },
    }
  );

  return (
    <div className="p-3 md:p-10">
      <div className="py-3">
        <nav class="flex" aria-label="Breadcrumb">
          <ol class="inline-flex items-center space-x-1 md:space-x-3">
            <li class="inline-flex items-center">
              <Link
                to="/"
                class="inline-flex items-center  font-medium text-gray-700 hover:text-gray-900 dark:text-gray-400 dark:hover:text-white"
              >
                Dashboard
              </Link>
            </li>
            <li>
              <div class="flex items-center">
                <svg
                  class="w-6 h-6 text-gray-400"
                  fill="currentColor"
                  viewBox="0 0 20 20"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fill-rule="evenodd"
                    d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
                    clip-rule="evenodd"
                  ></path>
                </svg>
                <Link
                  to="/ads"
                  class="ml-1  font-medium text-gray-700 hover:text-gray-900 md:ml-2 dark:text-gray-400 dark:hover:text-white"
                >
                  Ads
                </Link>
              </div>
            </li>
            <li aria-current="page">
              <div class="flex items-center">
                <svg
                  class="w-6 h-6 text-gray-400"
                  fill="currentColor"
                  viewBox="0 0 20 20"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fill-rule="evenodd"
                    d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
                    clip-rule="evenodd"
                  ></path>
                </svg>
                <span class="ml-1  font-medium text-gray-500 md:ml-2 dark:text-gray-400">
                  Details
                </span>
              </div>
            </li>
          </ol>
        </nav>
      </div>
      {propertyDetailsData?.isFetched ? (
        <div className="p-2 md:p-5 bg-white dark:bg-secondary-dark-bg rounded-md">
          <div className="h-44 md:h-80 relative">
            <img
              src={propertyDetailsData?.data?.data?.data?.images[0]}
              alt=""
              className="h-full rounded-md w-full object-cover"
            />
            <div className="absolute inset-0 bg-gradient-to-t  to-transparent opacity-75  " />
            <div className="absolute top-0 left-0 bg-[#216fed] px-6 p-2">
              <h1 className="font-medium    text-white rounded-r-md capitalize">
                for {propertyDetailsData?.data?.data?.data?.type}
              </h1>
            </div>
            <div className="absolute bottom-2 w-full flex flex-col items-center justify-center ">
              <h1 className="font-medium text-xl text-white line-clamp-1">
                {propertyDetailsData?.data?.data?.data.name}
              </h1>
              <div className="flex items-center space-x-4">
                <div className="flex items-center space-x-1">
                  <MdBathtub size={16} className=" font-medium text-white" />
                  <h1 className=" font-medium text-white">
                    {propertyDetailsData?.data?.data?.data?.details.bathroom}
                  </h1>
                </div>
                <div className="flex items-center space-x-1">
                  <MdBed size={16} className=" font-medium text-white" />
                  <h1 className=" font-medium text-white">
                    {propertyDetailsData?.data?.data?.data?.details.bedroom}
                  </h1>
                </div>
                <div className="flex items-center space-x-1">
                  <BiArea size={16} className=" font-medium text-white" />
                  <h1 className=" font-medium text-white">
                    {propertyDetailsData?.data?.data?.data?.details.area}
                  </h1>
                </div>
              </div>
            </div>
          </div>
          <div className="flex items-center justify-end w-full space-x-1 text-dark-color pt-1">
            <AiFillEye size={20} className="text-main-color" />
            <p className="font-medium text-sm text-dark-color dark:text-gray-300">
              {propertyDetailsData?.data?.data?.data?.views}
            </p>
          </div>
          {/* description */}
          <div className="pt-5 grid grid-cols-1 md:grid-cols-12 w-full gap-3">
            <div className="md:col-span-4 flex flex-col items-start space-y-2 w-full">
              <div className="w-full">
                <h1 className="font-bold text-dark-color dark:text-gray-300 text-xl py-2">
                  Agent Company
                </h1>
                <div className="bg-[#216fed] p-5 rounded-md">
                  <h1 className="font-bold text-white text-2xl capitalize">
                    {propertyDetailsData?.data?.data?.poster?.name}
                  </h1>
                </div>
              </div>
              <div className="w-full">
                <h1 className="font-bold text-dark-color dark:text-gray-300 text-xl py-2">
                  Owner
                </h1>
                <div className="bg-[#216fed] p-5 rounded-md">
                  <h1 className="font-bold text-white text-2xl capitalize">
                    {propertyDetailsData?.data?.data?.data?.owner?.name}
                  </h1>
                </div>
              </div>
              <h1 className="font-bold text-dark-color dark:text-gray-300 text-xl py-2 w-full">
                Price
              </h1>
              <div className="bg-[#216fed] p-5 rounded-md w-full">
                <h1 className="font-bold text-white text-xl md:text-3xl">
                  <span>ETB </span>
                  {propertyDetailsData?.data?.data?.data?.price}
                </h1>
              </div>
              <div className="w-full">
                <h1 className="font-bold text-dark-color dark:text-gray-300 text-xl py-2">
                  Agent
                </h1>
                <div>
                  <div className="flex items-center space-x-2">
                    <img
                      src={
                        propertyDetailsData?.data?.data?.data?.agents?.profile
                      }
                      alt=""
                      className="h-14 w-14 rounded-full object-cover"
                    />
                    <div className="flex flex-col">
                      <p className="font-medium text-dark-color dark:text-gray-300 text-sm">
                        {propertyDetailsData?.data?.data?.data?.agents
                          ?.firstName +
                          " " +
                          propertyDetailsData?.data?.data?.data?.agents
                            ?.lastName}
                      </p>
                      <div className="flex flex-col items-start space-y-2">
                        {propertyDetailsData?.data?.data?.data?.agents?.phone?.map(
                          (item) => (
                            <p className="font-normal text-dark-gray dark:text-gray-300 text-sm">
                              {item}
                            </p>
                          )
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* second grid */}
            <div className="md:col-span-8 flex flex-col space-y-2">
              <h1 className="font-bold text-dark-color dark:text-gray-300 text-xl">
                Description
              </h1>
              <p className="font-normal text-dark-gray text-sm">
                {propertyDetailsData?.data?.data?.data?.description}
              </p>
              {/* carausel */}
              <div className="">
                <h1 className="font-bold text-dark-color dark:text-gray-300 p-2 text-xl">
                  Images
                </h1>
                <Carousel
                  infinite
                  customLeftArrow={customLeftArrow}
                  customRightArrow={customRightArrow}
                  responsive={responsive}
                  itemClass="px-2"
                  swipeable={true}
                  draggable={true}
                  autoPlay={true}
                >
                  {propertyDetailsData?.data?.data?.data?.images?.map(
                    (img, i) => (
                      <img
                        src={img}
                        className="max-w-[500px] max-h-[200px] h-full w-full object-cover rounded-md"
                      />
                    )
                  )}
                </Carousel>
              </div>
              {/* location */}
              <h1 className="font-bold text-dark-color dark:text-gray-300 p-2 text-xl">
                Location
              </h1>
              <div className="h-64 rounded-lg">
                <GoogleMapReact
                  bootstrapURLKeys={{
                    key: "AIzaSyDd81MpJcxjNdICQeKRg3Emywp4e_29Sfc",
                  }}
                  defaultCenter={defaultProps.center}
                  defaultZoom={10}
                  options={""}
                  onChange={""}
                  onChildClick={(e) => console.log(e)}
                  margin={[50, 50, 50, 50]}
                >
                  <div
                    lat={
                      propertyDetailsData?.data?.data?.data?.address?.latitude
                    }
                    lng={
                      propertyDetailsData?.data?.data?.data?.address?.longtude
                    }
                  >
                    <FaMapMarkerAlt size={30} className="text-main-color" />
                  </div>
                </GoogleMapReact>
              </div>
              {/* amenities */}
              <h1 className="font-bold text-dark-color dark:text-gray-300 pt-2 text-xl">
                Amenities
              </h1>
              <div className="grid grid-cols-2 md:grid-cols-3 gap-3 py-3">
                {propertyDetailsData?.data?.data?.data?.amenities?.map(
                  (item) => (
                    <div className="flex items-center space-x-2">
                      <BsFillPatchCheckFill className="text-green-500" />
                      <h1 className="font-bold text-dark-color dark:text-gray-300 ">
                        {item}
                      </h1>
                    </div>
                  )
                )}
              </div>

              <div className="flex items-center justify-center w-full space-x-10">
                <button
                  onClick={() => handleAccept(id)}
                  className="bg-blue-bg hover:opacity-80 text-white 
                   font-medium rounded-sm p-2 px-10"
                >
                 {acceptAdData.isLoading ?   'Loading' :' Accept Ad'}
                </button>
                <button
                  onClick={() => handleReject(id)}
                  className="bg-red-500 hover:opacity-80 text-white 
                   font-medium rounded-sm p-2 px-10"
                >
                  {rejectAdData.isLoading ?  'Loading...' :'Reject Ad'}
                </button>
              </div>
            </div>
          </div>
        </div>
      ) : (
        <div className="flex items-center justify-center">
          <ThreeDots
            height="80"
            width="80"
            radius="9"
            color="#216fed"
            ariaLabel="three-dots-loading"
            wrapperStyle={{}}
            wrapperClassName=""
            visible={true}
          />
        </div>
      )}
      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover={false}
        transition={Slide}
      />
    </div>
  );
};

export default AdsDetail;
